module.exports = __webpack_public_path__ + "img/number2.135669a3.gif";